var React = require('react');

function Battlecruiser (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Battlecruiser"),React.createElement("g",{"id":"g1421","key":2},[React.createElement("path",{"id":"path877","className":"cls-1","d":"M114,58.56l-50-50-50,50v40H114Z","key":0}),React.createElement("path",{"id":"path879","className":"cls-1","d":"M14,118.56H114","key":1})])]);
}

Battlecruiser.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Battlecruiser;

Battlecruiser.default = Battlecruiser;
